import axios from 'axios';
import { getNonce, clearNonce } from './nonceStorage';

// Adres instancji WooCommerce.
const WOOCOMMERCE_URL = 'https://hardshop.hard-adv.com';

// ------------------------------------------------------------
// withCredentials: true — CELOWO.
// ------------------------------------------------------------
// Dzięki temu, że logowanie (krok 4) ustawia PRAWDZIWE ciasteczko sesji WP
// (przez mu-plugin react-sso-auth.php) i dokładamy do żądań nonce (poniżej),
// CoCart poprawnie rozpoznaje zalogowanego użytkownika, a klasyczna kasa
// WooCommerce zgadza się z Reactem co do tego, kto jest zalogowany. Dla
// koszyka gościa (obecny krok) to pole nie przeszkadza — CoCart obsługuje
// wtedy sesję po prostu przez cart_key.
// ------------------------------------------------------------
export const cocartClient = axios.create({
    baseURL: `${WOOCOMMERCE_URL}/wp-json/cocart/v2`,
    headers: {
        'Content-Type': 'application/json',
    },
    withCredentials: true,
});

cocartClient.interceptors.request.use(
    (requestConfig) => {
        const nonce = getNonce();
        if (nonce) {
            requestConfig.headers = requestConfig.headers || ({} as any);
            (requestConfig.headers as any)['X-WP-Nonce'] = nonce;
        }
        return requestConfig;
    },
    (error) => Promise.reject(error),
);

cocartClient.interceptors.response.use(
    (response) => response,
    (error) => {
        // Anulowane żądanie (np. superseded przez nowsze) to oczekiwane
        // zachowanie, a nie błąd.
        if (axios.isCancel(error) || error.code === 'ERR_CANCELED') {
            return Promise.reject(error);
        }

        const status = error.response?.status;

        // Ciasteczko sesji wygasło/nonce się zdezaktualizował — czyścimy
        // lokalny nonce i informujemy o tym przez zdarzenie na window
        // (żeby uniknąć zależności cyklicznej z kontekstem logowania,
        // który dodamy w kroku 4).
        if ((status === 401 || status === 403) && getNonce()) {
            clearNonce();
            window.dispatchEvent(new Event('cocart:auth-invalid'));
        }

        console.error('❌ Błąd CoCart:', error.response?.data || error.message);
        return Promise.reject(error);
    },
);

export default WOOCOMMERCE_URL;
